import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    licenseList: []
}

const mutations = {
    CLEAR_LICENSE_STATE(state) {
        state.licenseList = [];
    },
    SET_LICENSE_DETAILS(state, licenseData) {
        var tData = {};
        var parseData = licenseData.message;
        if (Object.keys(state.licenseList).length == 0) {
            tData[licenseData.accountId + '-licenseList'] = parseData;
            state.licenseList = tData;
        } else {
            Vue.set(state.licenseList, licenseData.accountId + '-licenseList', parseData);
        }
    },
}

const actions = {
    clearUsersState({
        commit,
        dispatch
    }) {
        commit('CLEAR_LICENSE_STATE')
    },
    fetchLicenseDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/license/index/true")
            .then(response => {
                Nprogress.done()
                commit('SET_LICENSE_DETAILS', response.data)
            })
            .catch(error => console.log(error))
    },
    uploadLicenseSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("/license/import_license/true", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}

const getters = {
    getLicenseGetters: state => {
        return state.licenseList;
    },
}


export default {
    state,
    mutations,
    actions,
    getters
}